export default __webpack_public_path__ + "static/media/mobile-job_1.1e0ea008.png";